import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMagic, faUndo } from '@fortawesome/free-solid-svg-icons'
import { animateScroll } from "react-scroll"
import classNames from 'classnames'
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { isEqual, property } from 'lodash'


import styles from './dashboard.css'
import ObjectsList from './ObjectsList.jsx'
import ObjectOptions from './ObjectOptions.jsx'
import DashboardMenu from './DashboardMenu.jsx'
import DashboardMenuEmbedded from './embedded/DashboardMenu'

import { yamlToTemplate, convertTemplateToNewerVersion } from '../template/converters'
import Endpoints from '../../api/methods'

import {
  setPdfFile,
  convertToPdf,
  setPdfUrl,
  detectMacro,
  detectFields,
  detectGridStructure,
  setTestFieldResultId,
  uploadFileFromUrl,
  markFailToFileUploaded, markSuccessToFileUploaded
} from "./actions.jsx";
import { setActiveObject, resetPdfFileAndUrl, runTemplate, runTemplateWithOneObject, setIsCustomFile, setPdfFileName, uploadSampleDocumentFromUrl } from '../pdfViewer/actions.jsx'
import {
  changeObjectName,
  changeTemplateName,
  changeObjectDataType,
  changeObjectExpression,
  changeObjectCoalescingObject,
  changeObjectDateFormat,
  addDefaultRectangleField,
  addDefaultRectangleFieldBarcode,
  changeTableRowMergingRule,
  addDefaultStaticField,
  addDefaultTextSearchField,
  addDefaultTextSearchFieldKeyValue,
  addDefaultSearchBasedTable,
  addDefaultSearchBasedTableWithAutoDetection,
  changeSearchBasedTableProperties,
  addDefaultGridCellField,
  changeGridCellFieldColumn,
  changeGridCellFieldRow,
  setTemplate,
  deleteObject,
  resetTemplate,
  setRegexStatusToObject,
  addDefaultRectangleTable,
  undoObjectChanges, changeObjectPageIndex,
  sortTemplateObjects
} from "../template/actions.jsx";
import { openTemplateSettingsModal, openEditTemplateModal, openMacrosModal } from '../modals/actions'
import { openRunTemplateResultWindow, openRunObjectResultWindow } from '../windows/actions'
import { setIsTemplateModified, setTemplateFileName } from '../editor/actions'
import { getBase64 } from '../../utils/base64.jsx'
import { getBlankPdf } from '../../constants/blankPdf'
import ReactDOM from "react-dom";
import TemplateToolbar from "../templateToolbar/TemplateToolbar";
import { ALERT_MODALS, TEMPLATE_PDF_ACTIONS } from "../../constants/app";
import RequiredPdfForVirtualFieldAlertModal
  from "../modals/requiredPdfForVirtualFieldAlertModal/RequiredPdfForVirtualFieldAlertModal";
import SampleTemplatesModal from "../modals/sampleTemplatesModal/SampleTemplatesModal";
import { imageToPdf } from "../../utils/imageToPdf";

class DashboardMenuPortal extends React.Component {
  state = {
    isWait: true,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isWait: false,
        currentShowAlertModal: null
      });
    }, 100);
  }

  render() {
    if (this.state.isWait) {
      return 'Loading...';
    }

    return ReactDOM.createPortal(
      this.props.dashboardMenu,
      document.querySelector(".js-dashboard-menu-portal")
    );
  }
}

class Dashboard extends React.Component {
  constructor(props) {
    super(props)

    props.setPdfFile(getBlankPdf())

    this.state = {
      fileName: "Choose file",
    }
  }

  handleFileUploaded = async (files) => {
    if (files && files.length) {
      const { setPdfFile, resetPdfFileAndUrl, setIsCustomFile, setPdfFileName, markFailToFileUploaded, markSuccessToFileUploaded } = this.props

      this.setState({
        fileName: "Choose file"
      });

      markFailToFileUploaded();

      resetPdfFileAndUrl()

      setPdfFileName(files[0].name)

      const mimeType = files[0].type;
      let fileData;

      if (mimeType === 'application/pdf') {
        fileData = files[0];
      } else if (["image/jpeg", "image/png"].includes(mimeType)) {

        const pdfData = await imageToPdf(files[0], mimeType);
        fileData = new Blob([pdfData], { type: "application/pdf" });
      }

      getBase64(fileData, (result) => {
        setPdfFile(result)
        setIsCustomFile(true)

        this.setState({
          fileName: files[0].name
        })

        markSuccessToFileUploaded();
      })
    }

  }

  handleTemplateUploaded = (e) => {
    const files = e.target.files
    var self = this
    var fr = new FileReader();
    const extension = files[0].name.split('.').pop()

    this.props.setTemplateFileName(files[0].name)

    fr.onload = function (e) {
      if (extension == 'json') {
        var result = JSON.parse(e.target.result)
      } else if (extension == 'yml') {
        var result = yamlToTemplate(e.target.result)
      }

      if (parseInt(result.templateVersion) < 4) {
        Endpoints.convertTemplateToNewerVersion(result)
          .then(result => {
            setTemplate(result.template)
          })
          .catch(err => {
            alert("Template version is too old, error converting to newer version")
          })
      } else {
        setTemplate(result)
      }
    }

    fr.readAsText(files.item(0));

    e.target.value = ""

    function setTemplate(template) {
      try {
        self.setTemplateByJson(template)
      } catch (e) {
        console.log(e, "Template error")
        alert("Template error")
      }
    }
  }

  /**
   * loads sample template from the templateUrl and loads pdf from the file
   * @param  sampleTemplate : selected sample template data from the dropdown
   */

  handleUploadTemplateFromUrl = async (template) => {
    const { uploadFileFromUrl } = this.props;
    let self = this;
    const extension = template.templateUrl.split('.').pop();
    this.props.setTemplateFileName(template.label);

    uploadFileFromUrl(template.templateUrl, async url => {
      const templateData = await Endpoints.getSampleTemplate(url)

      if (extension == 'json') {
        //var result = JSON.parse(templateData.data)
        var result = templateData.data
      } else if (extension == 'yml') {
        var result = yamlToTemplate(templateData.data)
      }

      // Use Label of sample template because the templateName returned from API is wrong
      if (parseInt(result.templateVersion) < 4) {
        Endpoints.convertTemplateToNewerVersion(result)
          .then(data => {
            setTemplate({
              ...data.template,
              templateName: template.label
            })
          })
          .catch(err => {
            alert("Template version is too old, error converting to newer version")
          })
      } else {
        setTemplate({
          ...result,
          templateName: template.label
        })
      }
    })

    function setTemplate(template) {
      try {
        self.setTemplateByJson(template)
      } catch (e) {
        console.log(e, "Template error")
        alert("Template error")
      }
    }
  }

  handleLoadSampleTemplate = async (sampleTemplate) => {
    const { setPdfUrl, resetPdfFileAndUrl, setIsCustomFile, setPdfFileName, uploadFileFromUrl, uploadSampleDocumentFromUrl, markFailToFileUploaded, markSuccessToFileUploaded } = this.props
    var self = this
    const extension = sampleTemplate.templateUrl.split('.').pop();
    this.props.setTemplateFileName(sampleTemplate.label);

    uploadFileFromUrl(sampleTemplate.templateUrl, async url => {
      const templateData = await Endpoints.getSampleTemplate(url)

      if (extension == 'json') {
        //var result = JSON.parse(templateData.data)
        var result = templateData.data
      } else if (extension == 'yml') {
        var result = yamlToTemplate(templateData.data)
      }

      // Use Label of sample template because the templateName returned from API is wrong
      if (parseInt(result.templateVersion) < 4) {
        Endpoints.convertTemplateToNewerVersion(result)
          .then(data => {
            setTemplate({
              ...data.template,
              templateName: sampleTemplate.label
            })
          })
          .catch(err => {
            alert("Template version is too old, error converting to newer version")
          })
      } else {
        setTemplate({
          ...result,
          templateName: sampleTemplate.label
        })
      }
    })

    markFailToFileUploaded();

    resetPdfFileAndUrl()
    setPdfFileName(sampleTemplate.label)

    uploadSampleDocumentFromUrl(sampleTemplate.testDocumentUrl, url => {
      setPdfUrl(url)
      setIsCustomFile(true)

      markSuccessToFileUploaded();
    })

    setIsCustomFile(true)

    function setTemplate(template) {
      try {
        self.setTemplateByJson(template)
      } catch (e) {
        console.log(e, "Template error")
        alert("Template error")
      }
    }
  }

  setTemplateByJson = (result) => {
    const { setTemplate } = this.props

    result.objects = result.objects.map((obj, i) => {
      return {
        ...obj,
        id: i
      }
    })
    result.culture = result.culture || "en-US"
    result.description = result.description || ""
    result.options = result.options || {}
    result.options.ocrMode = result.options.ocrMode || "auto"
    result.options.ocrLanguage = result.options.ocrLanguage || "eng"
    result.options.ocrResolution =  result.options.ocrResolution || 300
    result.options.ocrImageFilters =  result.options.ocrImageFilters || ""
    result.options.ocrWhiteList =  result.options.ocrWhiteList || ""
    result.options.ocrBlackList =  result.options.ocrBlackList || ""

    setTemplate(result)
  }

  handleUploadClick = (e) => {
    this.uploadRef.click()
  }

  runTemplate = (e) => {
    this.props.runTemplate(this.props.openRunTemplateResultWindow)
  }

  runTemplateWithOneObject = (id, type) => {
    const { openRunObjectResultWindow, setTestFieldResultId } = this.props

    this.props.runTemplateWithOneObject(id, () => {
      if (type == "field") {
        setTestFieldResultId(id)
      } else {
        openRunObjectResultWindow()
      }

      animateScroll.scrollToBottom({
        containerId: "dashboard",
        duration: 50
      })
    })
  }

  resetTemplate = () => {
    if (!this.props.isTemplateModified || window.confirm("Are you sure?")) {
      this.props.resetTemplate()
    }
  }

  addObject = (type) => {
    if (type == "placeholder") {
      return
    }

    switch (type) {
      case "rectangle-field":
        return this.props.addDefaultRectangleField(this.props.page - 1, (id) => {
          this.props.setActiveObject(id)
        })
      case "rectangle-field-barcode":
        return this.props.addDefaultRectangleFieldBarcode(this.props.page - 1, (id) => {
          this.props.setActiveObject(id)
        })  
      case "rectangle-table":
        return this.props.addDefaultRectangleTable(this.props.page - 1, (id) => {
          this.props.setActiveObject(id)
        })
      case "static-field":
        return this.props.addDefaultStaticField(this.props.page - 1, (id) => {
          this.props.setActiveObject(id)
        })
      case "text-search-field-key-value":
        return this.props.addDefaultTextSearchFieldKeyValue((id) => {
          this.props.setActiveObject(id)
        })
      case "text-search-field":
        return this.props.addDefaultTextSearchField((id) => {
          this.props.setActiveObject(id)
        })  
      case "search-based-table":
        return this.props.addDefaultSearchBasedTable((id) => {
          this.props.setActiveObject(id)
        })
      case "search-based-table-auto":
        return this.props.addDefaultSearchBasedTableWithAutoDetection((id) => {
          this.props.setActiveObject(id)
        })  
      case "grid-cell-field":
        return this.props.addDefaultGridCellField(this.props.page - 1, (id) => {
          this.props.setActiveObject(id);
          // Auto show the Virtual Grid Selector when add this field to the existing pdf
          if (this.props.isCustomFile) {
            this.props.detectGridStructure(id);
          }
        })
    }
  }

  handleDeleteConfirm = (e) => {
    if (window.confirm("Are you sure?")) {
      this.props.deleteObject(this.props.activeObjectId)
    }
  }

  handleUploadPdf = () => {
    if (process.env.REACT_APP_DOCPARSER_TEMPLATE_EDITOR_EMBEDDED == 1) {
      this.embeddedMenuRef.handleUploadClick()
    }
    else {
      this.menuRef.handleUploadClick()
    }
  }

  handleClickUndo = () => {
    this.props.undoObjectChanges()
  }

  renderTooltip = (name, id, props) => (
    <Tooltip id={id} {...props} className="tooltip-btn">
      {name}
    </Tooltip>
  );

  handleAddGridCellField = () => {
    this.addObject("grid-cell-field");
    if (!this.props.isCustomFile) {
      this.setState({
        currentShowAlertModal: ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL
      });
    }
  }

  handleOpenSampleTemplate = () => {
    if (this.props.isTemplateModified && !window.confirm("Are you sure you want to discard all changes in the current template without saving?")) {
      return;
    }
    this.props.setOpenSampleTemplatesModal(true);
  };

  handleCreateNewTemplate = (templateAction, file) => {
    if (templateAction === TEMPLATE_PDF_ACTIONS.LOAD_PDF_FROM_FILE.value) {
      this.handleFileUploaded(file);
    }
    this.resetTemplate();
  }

  handleCloseSampleTemplate = () => {
    this.props.setOpenSampleTemplatesModal(false);
  }

  handleClickLoadSample = (option, templateAction, file) => {
    switch (templateAction) {
      case TEMPLATE_PDF_ACTIONS.LOAD_FOR_THIS_TEMPLATE.value: {
        this.handleLoadSampleTemplate(option);
        break;
      }

      case TEMPLATE_PDF_ACTIONS.LOAD_CURRENTLY_PDF.value: {
        this.handleUploadTemplateFromUrl(option);
        break;
      }

      case TEMPLATE_PDF_ACTIONS.LOAD_PDF_FROM_FILE.value: {
        this.handleUploadTemplateFromUrl(option);
        this.handleFileUploaded(file);
        break;
      }

      default: {
        this.handleUploadTemplateFromUrl(option);
        break;
      }
    }
  }

  render() {
    var dashboardMenu = null
    const activeObject = this.props.objects && this.props.objects.length ? this.props.objects.find(obj => {
      return obj["id"] == this.props.activeObjectId
    }) : undefined

    const templateNameClassNames = classNames("form-group row", { hidden: !this.props.fileUploaded })

    const undoable = !isEqual(this.props.objects, this.props.oldObjects);

    // console.log("undoable, objects, oldObjects", undoable, this.props.objects, this.props.oldObjects)

    if (process.env.REACT_APP_DOCPARSER_TEMPLATE_EDITOR_EMBEDDED == 1) {
      //console.log(`loading embedded menu`);

      dashboardMenu = <DashboardMenuEmbedded
        handleFileUploaded={this.handleFileUploaded}
        template={this.props.template}
        templateName={this.props.templateName}
        fileUploaded={this.props.fileUploaded}
        handleTemplateUploaded={this.handleTemplateUploaded}
        handleLoadSampleTemplate={this.handleLoadSampleTemplate}
        handleEditClick={this.props.openEditTemplateModal}
        resetTemplate={this.resetTemplate}
        handleRunTemplate={this.runTemplate}
        isRunningTemplate={this.props.isRunningTemplate}
        isCustomFile={this.props.isCustomFile}
        setIsTemplateModified={this.props.setIsTemplateModified}
        isTemplateModified={this.props.isTemplateModified}
        disableUnloadAlert={this.props.disableUnloadAlert}
        handleUploadTemplateFromUrl={this.handleUploadTemplateFromUrl}
        handleOpenSampleTemplate={this.handleOpenSampleTemplate}
        ref={(ref) => this.embeddedMenuRef = ref}
      />
    } else {
      //console.log(`loading non-embedded menu`);

      dashboardMenu = <DashboardMenu
        handleFileUploaded={this.handleFileUploaded}
        template={this.props.template}
        templateName={this.props.templateName}
        fileUploaded={this.props.fileUploaded}
        handleTemplateUploaded={this.handleTemplateUploaded}
        handleLoadSampleTemplate={this.handleLoadSampleTemplate}
        handleEditClick={this.props.openEditTemplateModal}
        resetTemplate={this.resetTemplate}
        handleRunTemplate={this.runTemplate}
        isRunningTemplate={this.props.isRunningTemplate}
        isCustomFile={this.props.isCustomFile}
        setIsTemplateModified={this.props.setIsTemplateModified}
        isTemplateModified={this.props.isTemplateModified}
        handleUploadTemplateFromUrl={this.handleUploadTemplateFromUrl}
        handleOpenSampleTemplate={this.handleOpenSampleTemplate}
        ref={(ref) => this.menuRef = ref}
      />
    }

    const handleMouseEnter = () => {
      this.props.handleEnterExpandArea()
    }
  
    const handleMouseLeave = () => {
      this.props.handleLeaveExpandArea()
    }    

    return (
      <div className="container dashboard bg-light" id="dashboard"
      >
        <div className="row">
          <div className="col-lg-12 pl-0">
            <DashboardMenuPortal dashboardMenu={dashboardMenu} />
            <div className="form-group row ta-left">
              <TemplateToolbar/>
              <div className="col-lg-12">
                <div
                  disabled={this.props.isRunningTemplate || !this.props.isCustomFile || this.props.detectingFields}
                  className="d-flex justify-content-between"
                >
                  <div>
                    <div className="d-inline-flex">
                      <Dropdown>
                        <OverlayTrigger   placement="top"
                                          delay={{ show: 250, hide: 400 }}
                                          overlay={(props) => this.renderTooltip("Add Object", "add_object_id", props)}>
                          <Dropdown.Toggle variant="primary" id="dropdown-basic">
                            <FontAwesomeIcon icon={faPlus} /> Add Object
                          </Dropdown.Toggle>
                        </OverlayTrigger>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={this.handleAddGridCellField}>Add FIELD from VIRTUAL GRID</Dropdown.Item>
                          <Dropdown.Item onClick={e => this.addObject("rectangle-field")}>Add FIELD from RECTANGLE selection</Dropdown.Item>
                          <Dropdown.Item onClick={e => this.addObject("rectangle-field-barcode")}>Add FIELD from RECTANGLE selection with BARCODE</Dropdown.Item>

                          <Dropdown.Item onClick={e => this.addObject("text-search-field-key-value")}>Add FIELD from KEY VALUE extraction</Dropdown.Item>

                          <Dropdown.Item onClick={e => this.addObject("rectangle-table")}>Add TABLE from RECTANGLE selection</Dropdown.Item>

                          <Dropdown.Item onClick={e => this.addObject("text-search-field")}>Add FIELD from TEXT SEARCH</Dropdown.Item>

                          <Dropdown.Item onClick={e => this.addObject("search-based-table-auto")}>Add TABLE from TABLE AUTO DETECTION</Dropdown.Item>

                          <Dropdown.Item onClick={e => this.addObject("search-based-table")}>Add TABLE from TEXT SEARCH</Dropdown.Item>


                          <Dropdown.Item onClick={e => this.addObject("static-field")}>Add FIELD with STATIC value </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    {/*
                  <button
                    disabled={this.props.isRunningTemplate || this.props.detectingFields}
                    className="btn btn-danger mL-10" data-toggle="tooltip" data-placement="bottom" title="Delete object" onClick={this.handleDeleteConfirm}>
                    <FontAwesomeIcon icon={faTrash} /> Delete Object
                  </button>
*/}

                    <OverlayTrigger   placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={(props) => this.renderTooltip("Detect Objects..", "detect_objects_id", props)}>
                      <button disabled={this.props.isRunningTemplate || this.props.detectingFields}
                        className="btn btn-sm btn-warning mL-10"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Detect Objects.."
                        onClick={this.props.detectFields}>
                        <FontAwesomeIcon icon={faMagic} /> {this.props.detectingFields ? 'Detecting...' : 'Detect Objects..'}
                      </button>
                    </OverlayTrigger>
                  </div>

                  <OverlayTrigger   placement="top"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={(props) => this.renderTooltip("Undo", "undo_id", props)}>
                    <button onClick={this.handleClickUndo} className="btn btn-primary" disabled={!undoable}><FontAwesomeIcon icon={faUndo} /> Undo</button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            {this.props.fileUploaded }

            <div>
              <ObjectsList
                isRunningTemplate={this.props.isRunningTemplate}
                handleOpenSampleTemplate={this.handleOpenSampleTemplate}
                activeObjectId={this.props.activeObjectId}
                isTemplateModified={this.props.isTemplateModified}
                isCustomFile={this.props.isCustomFile}
                setActiveObject={this.props.setActiveObject}
                objects={this.props.objects}
                tabindex="0"
                deleteObject={this.props.deleteObject}      
                sortTemplateObjects={this.props.sortTemplateObjects}
              />

              <div 
                //onMouseEnter={() => handleMouseEnter()}
                //onMouseLeave={() => handleMouseLeave()}                    
              >
              <ObjectOptions
                object={activeObject}
                totalPages={this.props.totalPages}
                objects={this.props.objects}
                changeObjectName={this.props.changeObjectName}
                changeObjectDataType={this.props.changeObjectDataType}
                changeObjectPageIndex={this.props.changeObjectPageIndex}
                changeObjectExpression={this.props.changeObjectExpression}
                changeObjectDateFormat={this.props.changeObjectDateFormat}
                changeObjectCoalescingObject={this.props.changeObjectCoalescingObject}
                changeTableRowMergingRule={this.props.changeTableRowMergingRule}
                changeSearchBasedTableProperties={this.props.changeSearchBasedTableProperties}
                changeGridCellFieldColumn={this.props.changeGridCellFieldColumn}
                changeGridCellFieldRow={this.props.changeGridCellFieldRow}
                openMacrosModal={this.props.openMacrosModal}
                setRegexStatusToObject={this.props.setRegexStatusToObject}
                handleRunTemplate={this.runTemplate}
                isRunningTemplate={this.props.isRunningTemplate}
                isTemplateModified={this.props.isTemplateModified}
                runTemplateWithOneObject={this.runTemplateWithOneObject}
                isCustomFile={this.props.isCustomFile}
                detectMacro={this.props.detectMacro}
                detectingMacro={this.props.detectingMacro}
                detectingFields={this.props.detectingFields}
                detectGridStructure={this.props.detectGridStructure}
                runTemplateResult={this.props.runTemplateResult}
                testFieldResultId={this.props.testFieldResultId}
                handleUploadPdf={this.handleUploadPdf}
                handleEnterExpandArea={this.props.handleEnterExpandArea}
                handleLeaveExpandArea={this.props.handleLeaveExpandArea}
                handleOpenSampleTemplate={this.handleOpenSampleTemplate}
              />
              </div>
            </div>
          </div>
        </div>
        {this.state.currentShowAlertModal === ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL && (
          <RequiredPdfForVirtualFieldAlertModal isOpen={this.state.currentShowAlertModal === ALERT_MODALS.PDF_VIRTUAL_FIELD_ALERT_MODAL}
                                                handleClose={() => this.setState({currentShowAlertModal: null}) }
                                                handleUploadPdf={this.handleUploadPdf}/>
        )}

        <SampleTemplatesModal handleClose={this.handleCloseSampleTemplate} isOpen={this.props.isOpenSampleTemplatesModal} handleClickLoadSample={this.handleClickLoadSample} handleCreateNewTemplate={this.handleCreateNewTemplate}/>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    objects: state.template.objects,
    oldObjects: state.template.oldObjects,
    activeObjectId: state.pdfViewer.activeObjectId,
    templateName: state.template.templateName,
    page: state.pdfViewer.page,
    totalPages: state.pdfViewer.totalPages,
    template: state.template,
    isRunningTemplate: state.pdfViewer.isRunningTemplate,
    runTemplateResult: state.pdfViewer.runTemplateResult,
    isCustomFile: state.pdfViewer.isCustomFile,
    detectingMacro: state.pdfViewer.detectingMacro,
    detectingFields: state.pdfViewer.detectingFields,
    testFieldResultId: state.dashboard.testFieldResultId,
    isTemplateModified: state.editor.isTemplateModified,
    fileUploaded: state.dashboard.fileUploaded
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setPdfFile,
    setActiveObject,
    changeObjectName,
    changeTemplateName,
    changeObjectDataType,
    changeObjectPageIndex,
    changeObjectExpression,
    changeObjectDateFormat,
    changeObjectCoalescingObject,
    addDefaultRectangleField,
    addDefaultRectangleFieldBarcode,
    addDefaultRectangleTable,
    addDefaultStaticField,
    changeTableRowMergingRule,
    addDefaultTextSearchField,
    addDefaultTextSearchFieldKeyValue,
    addDefaultSearchBasedTable,
    addDefaultSearchBasedTableWithAutoDetection,
    addDefaultGridCellField,
    changeSearchBasedTableProperties,
    changeGridCellFieldColumn,
    changeGridCellFieldRow,
    setTemplate,
    deleteObject,
    openTemplateSettingsModal,
    convertToPdf,
    setPdfUrl,
    resetPdfFileAndUrl,
    openEditTemplateModal,
    openMacrosModal,
    setRegexStatusToObject,
    resetTemplate,
    runTemplate,
    runTemplateWithOneObject,
    openRunObjectResultWindow,
    setIsCustomFile,
    detectMacro,
    detectFields,
    detectGridStructure,
    openRunTemplateResultWindow,
    setTestFieldResultId,
    setIsTemplateModified,
    setPdfFileName,
    uploadFileFromUrl,
    uploadSampleDocumentFromUrl,
    setTemplateFileName,
    undoObjectChanges,
    markFailToFileUploaded,
    markSuccessToFileUploaded,
    sortTemplateObjects
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
